class ValidateEmail extends ValidatePage {
    constructor(_parent) {
        super();
        this.parent = _parent;
        this.regex = /^\b[A-Z0-9._%-+]+[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,63}\b$/i;
        this.email = { elm: '', id: '', classlist: '',  value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidateEmail; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.email = this.parent.define_elem($this);
        var basic_validation = this.process_validations();

        if(basic_validation)
            this.is_valid = await this.validateEntry_Email();
        else
            this.is_valid = basic_validation;
        
        if(this.debug)
            console.log(this, "ValidateEmail - this");
        
        return this.is_valid;
    }

    async validateEntry_Email(){
        try{
            var table = this.email.id === 'c_email' ? 'company' : 'contact';
            var key = this.email.elm.attr('name');
            var s_perm = this.email.elm.val();

            if(!table){
                console.log("error");
                return;
            }

            const response = await am.$.ajax({
                url: `/ajax/validate_email/${table}/?${key}=${encodeURIComponent(s_perm)}`, // Replace with your server-side endpoint URL
                method: 'GET',
                data: { email: this.email.value }
            });
            
            this.response = response;
            
            if (response.valid){
                return true
            }else{
                if(response.sgEmailCheckObj && response.sgEmailCheckObj.resultObj && response.sgEmailCheckObj.resultObj.verdict && response.sgEmailCheckObj.resultObj.verdict == 'Invalid'){
                    var translation_str = get_language_translation('LANG_MSG_EMAIL_DOES_NOT_MEET_SECURITY_STDS_REACH_OUT_TO_VAR_FOR_ASSISTANCE');
                    const $instance = am.$('#installation-directory');
                    
                    let instance_name = 'Allmoxy'; // this will probably never be used but is here as a default
                    if($instance.length > 0)
                        instance_name = $instance.val();
                    
                    translation_str = translation_str.replace(/CONST_VAR_INSTANCE/g, instance_name);
                    this.parent.failed_obj_push( { target: this.email.id, msg:  translation_str } );
                }
                else{
                    this.parent.failed_obj_push( { target: this.email.id, msg: get_language_translation('EMAIL_ALREADY_TAKEN') } );
                }
                return false;
            }
        }
        catch(e){
            console.log(e);
        }
    }

    process_validations(){
        if(this.regex.test(this.email.value)){
            if(this.email.value.includes('@')){
                return true;
            }else{
                this.parent.failed_obj_push( { target: this.email.id, msg: get_language_translation('LANG_PASSWORD_INVALIDEMAIL') } );
                return false;
            }
        }else{
            this.parent.failed_obj_push( { target: this.email.id, msg: get_language_translation('VALID_EMAIL_REQUIRES_LANG') } );
            return false;
        }
    }
} 